export default __webpack_public_path__ + "static/CNA938-b4038962f7e6848052851f5499ba59ff.png";